import React, { Component } from "react";
import { Row, Col } from "shards-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, FormGroup, FormControl } from "react-bootstrap";
import lifeInsuranceService from "../../../../api/LifeInsurance/LifeInsuranceService";
export default class CreateLifeInsurance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lifeInsurance: { id: null, description: null, ar_description: null },
    };

    this.handleEvent = this.handleEvent.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.name !== this.state.name) {
      this.handler();
    }
  }

  componentWillUnmount() {}

  // Prototype methods, Bind in Constructor (ES2015)
  handleEvent() {}

  // Class Properties (Stage 3 Proposal)
  handler = () => {
    this.setState();
  };

  onCreateChange = (e) => {
    let lifeInsurance = this.state.lifeInsurance;
    lifeInsurance[e.target.name] = e.target.value;
    this.setState({ lifeInsurance });
  };

  onButtonClick = () => {
    lifeInsuranceService.addInsurance({
      description: this.state.lifeInsurance.description,
      ar_description: this.state.lifeInsurance.ar_description,
    });
    toast.success(`Life Insurance Created Successfully`, {
      position: toast.POSITION.TOP_CENTER,
    });
    this.setState({
      lifeInsurance: { id: null, description: null, ar_description: null },
    });
    document.getElementById("description").value = "";
    document.getElementById("ar_description").value = "";
  };

  render() {
    return (
      <>
        <h5 className="m-0">Create Life Insurance</h5>
        <Row form>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Description</label>
              <FormControl
                autoFocus
                type="text"
                name="description"
                id="description"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group mt-4">
            <FormGroup controlId="email" id="create-user">
              <label>Arabic Description</label>
              <FormControl
                autoFocus
                type="text"
                name="ar_description"
                id="ar_description"
                onChange={this.onCreateChange.bind(this)}
              />
            </FormGroup>
          </Col>
          <Col md="6" className="form-group pb-3 align-self-end" align="right">
            <Button
              className="btn btn-dark text-white w-25"
              onClick={this.onButtonClick.bind(this)}
            >
              Create
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}
